import { useEffect, useState } from "react";
 const KEY = "3edd0f8a";
export function useMovie(query){
    
        const [findMovies, setFinedMove] = useState([]);
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState("");

      useEffect(function () {
        // callback?.();
        const controller= new AbortController(); 
        const signal =controller.signal;
    
        async function fetchMovie() {
          try {
            setLoading(true);
            setError('');
            const res = await fetch(
              `https://www.omdbapi.com/?apikey=${KEY}&s=${query}`,
              {signal}
            );
    
            if (!res.ok)
              throw new Error("something went wrong with fetching movie");
            const data = await res.json();
              
            if (data.Response?.toLowerCase() === 'false') throw new Error("Movie not Found");
       
            setFinedMove(data.Search);
            setError("")
    
          } catch (err) {
            if(err.name !== 'AbortError') setError(err.message);
          } finally {
            setLoading(false);
          }
        }
        if(query.length<3){
          setFinedMove([]);
          setError('')
          return;
        }
        // handleCloseMovie();
        fetchMovie();
    
        return ()=>{
          controller.abort();
        }
      }, [query]);

      return {findMovies, error , loading}
    
}